/**
 * Both locale files are bundled statically. No HTTP backend, no lazy namespace loading:
 * two JSON files of a few kilobytes are cheaper to ship than the loading state they would
 * otherwise need, and a missing translation must never be a runtime network failure.
 */
import { SUPPORTED_LOCALES, type Locale } from '@tvitvi/shared';

import en from './locales/en.json';
import nb from './locales/nb.json';

export const DEFAULT_NAMESPACE = 'translation';

export const resources = {
  nb: { [DEFAULT_NAMESPACE]: nb },
  en: { [DEFAULT_NAMESPACE]: en },
} as const satisfies Record<Locale, Record<string, unknown>>;

export const LOCALE_LIST: readonly Locale[] = SUPPORTED_LOCALES;

export type TranslationResource = typeof nb;
